"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spaceSetting = exports.isBlockElement = void 0;
var _constants = require("../constants");
var isBlockElement = function isBlockElement(element) {
  return element && _constants.inlineElements.indexOf(element.type) === -1 && typeof element !== 'string';
};
exports.isBlockElement = isBlockElement;
var spaceSetting = function spaceSetting(_ref) {
  var _ref$verticalSpacing = _ref.verticalSpacing,
    verticalSpacing = _ref$verticalSpacing === void 0 ? 'sm' : _ref$verticalSpacing,
    _ref$horizontalSpacin = _ref.horizontalSpacing,
    horizontalSpacing = _ref$horizontalSpacin === void 0 ? 'sm' : _ref$horizontalSpacin,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? [] : _ref$children,
    _ref$flex = _ref.flex,
    flex = _ref$flex === void 0 ? false : _ref$flex;
  var verticalMargin = _constants.size[verticalSpacing] / (flex ? 2 : 1);
  return "\n    margin: 0px -".concat(_constants.size[horizontalSpacing] / 2, "px;\n\n    ").concat(isBlockElement(children[0]) || flex ? "margin-top: -".concat(verticalMargin, "px;") : '', "\n    ").concat(isBlockElement(children[children.length - 1]) || flex ? "margin-bottom: -".concat(verticalMargin, "px;") : '', "\n\n    > * {\n      margin: ").concat(verticalMargin, "px ").concat(_constants.size[horizontalSpacing] / 2, "px;\n    }\n  ");
};
exports.spaceSetting = spaceSetting;